import type {
  BlackbaudRaisersEdgeContactMappingStore,
  BlackbaudRaisersEdgeIntegration,
} from '@feathr/blackbox';
import { useCrmContactMappings } from '@feathr/extender/App/Settings/Account/CrmIntegrationPage/crmMappings.hooks';

/**
 * Loads (or reloads) the integration's contact mapping store on mount and returns it. Call it from
 * one owner component per page; others read `integration.contactMappingStore` from an `observer`.
 */
function useRaisersEdgeContactMappings(
  integration: BlackbaudRaisersEdgeIntegration,
): BlackbaudRaisersEdgeContactMappingStore {
  return useCrmContactMappings(integration);
}

export default useRaisersEdgeContactMappings;
